import { playerContentStartedV2 } from '@kinopoisk-int/evgen-web-events/web/player';

import { useEventCallback } from '@/scenarios/legacy-player/hooks/analytics/use-event-callback';

import { playerContent } from '../event-params-builders/player-content';

interface UiParams {
    contentId: string;
    psid: string;
    manifestUrl: string;
}

export function usePlayerContentStarted(uiParams: UiParams) {
    return useEventCallback({
        event: playerContentStartedV2,
        uiParams,
        eventParamsBuilder: playerContent,
    });
}
